// src/theme/minecraft.ts
import { theme } from 'antd';

export const techBlueTheme = {
  // 使用深色算法
  algorithm: theme.defaultAlgorithm,

  // 全局 Design Token
  token: {
    // 主色 - 亮蓝色（类似经典游戏标题）
    colorPrimary: '#4A9BD9',
    colorPrimaryHover: '#6BB5E8',
    colorPrimaryActive: '#3A8BC9',
    colorPrimaryBg: '#E0F0FF',

    // 功能色（糖果色系）
    colorSuccess: '#7BC87E',
    colorWarning: '#F7D44A',
    colorError: '#F28B82',
    colorInfo: '#4A9BD9',

    // 背景色系（米白/淡黄，模仿老式电视屏幕）
    colorBgBase: '#FEF7E0',
    colorBgContainer: '#FFFDF5',
    colorBgElevated: '#FFFFFF',
    colorBgLayout: '#F5EDD6',
    colorBgSpotlight: '#E8DCC8',

    // 文字色（深灰/黑色）
    colorTextBase: '#2A2A2A',
    colorTextSecondary: '#4A4A4A',
    colorTextTertiary: '#7A7A7A',
    colorTextQuaternary: '#AAAAAA',

    // 边框 - 粗、深色，带像素感
    colorBorder: '#3A3A3A',
    colorBorderSecondary: '#5A5A5A',

    // 无圆角（像素硬边）
    borderRadius: 0,
    borderRadiusSM: 0,
    borderRadiusLG: 0,
    borderRadiusXS: 0,
    borderRadiusOuter: 0,

    // 像素风格字体（需自行加载，如 "Press Start 2P", "PixelFont"）
    fontFamily: "'Press Start 2P', 'PixelFont', 'Courier New', monospace",
    fontFamilyCode: "'Press Start 2P', 'PixelFont', 'Courier New', monospace",

    // 阴影 - 使用内阴影模拟凸起/凹陷（纯像素风）
    boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
    boxShadowSecondary: 'inset -3px -3px 0 #3A3A3A, inset 3px 3px 0 #FFFFFF',

    // 控制组件尺寸（偏大，适合游戏风格）
    controlHeight: 36,
    controlHeightSM: 30,
    controlHeightLG: 44,
    controlHeightXS: 24,

    // 间距
    padding: 16,
    paddingSM: 12,
    paddingLG: 20,
    paddingXS: 8,
    margin: 16,
    marginSM: 12,
    marginLG: 20,
    marginXS: 8,

    // 粗边框
    lineWidth: 2,
    lineWidthBold: 4,

    // 动效（保留轻微过渡，但可禁用）
    motion: true,
    motionUnit: 0.1,
    motionBase: 0,
  },

  // 组件级定制
  components: {
    // ========== 通用组件 ==========

    Button: {
      borderRadius: 0,
      primaryShadow: 'inset -2px -2px 0 #2A5A7A, inset 2px 2px 0 #A0D0F0',
      defaultShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      defaultHoverBorderColor: '#4A9BD9',
      defaultHoverColor: '#2A2A2A',
      defaultHoverBg: '#E0F0FF',
      contentFontSize: 16,
      contentFontSizeLG: 18,
      contentFontSizeSM: 14,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      borderColor: '#3A3A3A',
      borderWidth: 2,
      fontWeight: '700',
    },

    // ========== 布局组件 ==========

    Grid: {},

    Layout: {
      headerBg: '#4A9BD9',
      headerColor: '#FFFFFF',
      headerPadding: '0 16px',
      bodyBg: '#F5EDD6',
      footerBg: '#4A9BD9',
      footerPadding: '8px 16px',
      triggerBg: '#FFFDF5',
      triggerColor: '#2A2A2A',
      triggerHeight: 48,
      zeroTriggerHeight: 48,
    },

    Space: {},

    Divider: {
      colorSplit: '#3A3A3A',
    },

    Flex: {},

    // ========== 导航组件 ==========

    Menu: {
      colorItemBg: 'transparent',
      colorSubItemBg: 'rgba(0,0,0,0.02)',
      colorItemText: '#4A4A4A',
      colorItemTextSelected: '#4A9BD9',
      colorItemBgSelected: 'rgba(74, 155, 217, 0.12)',
      colorItemBgActive: 'rgba(74, 155, 217, 0.06)',
      radiusItem: 0,
      controlHeightLG: 36,
      itemMarginInline: 0,
      borderColor: '#3A3A3A',
      borderWidth: 2,
    },

    Breadcrumb: {
      colorText: '#7A7A7A',
      colorTextSecondary: '#2A2A2A',
      lastItemColor: '#2A2A2A',
      separatorColor: '#AAAAAA',
    },

    Pagination: {
      borderRadius: 0,
      colorPrimary: '#4A9BD9',
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
    },

    Steps: {
      colorPrimary: '#4A9BD9',
      colorText: '#4A4A4A',
      colorTextSecondary: '#7A7A7A',
      colorBgContainer: '#FFFDF5',
      borderRadius: 0,
    },

    Tabs: {
      colorPrimary: '#4A9BD9',
      colorText: '#4A4A4A',
      colorTextActive: '#2A2A2A',
      colorTextHover: '#4A9BD9',
      colorBorder: '#3A3A3A',
      cardBg: '#FFFDF5',
      cardGutter: 2,
      horizontalMargin: '0 0 8px 0',
      horizontalItemGutter: 16,
    },

    Sider: {},

    // ========== 数据录入组件 ==========

    Input: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      colorPrimaryHover: '#4A9BD9',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      activeBg: '#FFFFFF',
      activeBorderColor: '#4A9BD9',
      hoverBorderColor: '#4A9BD9',
      borderWidth: 2,
    },

    Select: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      optionSelectedBg: 'rgba(74, 155, 217, 0.12)',
      optionActiveBg: 'rgba(74, 155, 217, 0.06)',
      borderWidth: 2,
    },

    Cascader: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      borderWidth: 2,
    },

    DatePicker: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      cellHeight: 28,
      cellWidth: 36,
      borderWidth: 2,
    },

    TimePicker: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      borderWidth: 2,
    },

    InputNumber: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      borderWidth: 2,
    },

    Checkbox: {
      colorPrimary: '#4A9BD9',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlInteractiveSize: 18,
    },

    Radio: {
      colorPrimary: '#4A9BD9',
      colorBorder: '#3A3A3A',
      radioSize: 18,
      dotSize: 8,
    },

    Switch: {
      colorPrimary: '#7BC87E',
      colorPrimaryHover: '#8FD892',
      handleBg: '#FFFDF5',
      handleShadow: 'inset -1px -1px 0 #3A3A3A, inset 1px 1px 0 #FFFFFF',
      trackHeight: 26,
      trackMinWidth: 48,
      innerMinMargin: 4,
    },

    Slider: {
      colorPrimary: '#4A9BD9',
      colorPrimaryHover: '#6BB5E8',
      colorPrimaryBorder: '#4A9BD9',
      colorPrimaryBorderHover: '#6BB5E8',
      trackBg: '#4A9BD9',
      trackHoverBg: '#6BB5E8',
      handleColor: '#4A9BD9',
      handleSize: 16,
      handleSizeHover: 18,
      dotSize: 8,
    },

    Rate: {
      colorPrimary: '#F7D44A',
      starSize: 22,
      starBg: '#D0C8A8',
    },

    Upload: {
      colorPrimary: '#4A9BD9',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      borderWidth: 2,
    },

    Form: {
      labelColor: '#2A2A2A',
      labelFontSize: 14,
      labelHeight: 36,
      itemMarginBottom: 16,
    },

    Mentions: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      borderWidth: 2,
    },

    AutoComplete: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      borderWidth: 2,
    },

    TreeSelect: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 30,
      borderWidth: 2,
    },

    ColorPicker: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      controlHeight: 36,
      borderWidth: 2,
    },

    Transfer: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      listWidth: 200,
      listHeight: 240,
      borderWidth: 2,
    },

    // ========== 数据展示组件 ==========

    Table: {
      borderColor: '#3A3A3A',
      headerBg: '#E0F0FF',
      headerColor: '#2A2A2A',
      headerSortActiveBg: '#D0E8F8',
      headerSortHoverBg: '#D0E8F8',
      rowHoverBg: 'rgba(74, 155, 217, 0.04)',
      rowSelectedBg: 'rgba(74, 155, 217, 0.10)',
      rowSelectedHoverBg: 'rgba(74, 155, 217, 0.16)',
      cellPaddingInline: 12,
      cellPaddingBlock: 10,
      borderRadius: 0,
      borderWidth: 2,
    },

    Card: {
      colorBgContainer: '#FFFDF5',
      colorBorderSecondary: '#3A3A3A',
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      borderRadiusLG: 0,
      padding: 16,
      paddingSM: 12,
      paddingLG: 20,
      headerBg: 'transparent',
      headerFontSize: 18,
      borderWidth: 2,
    },

    List: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      padding: 16,
      paddingSM: 12,
      paddingLG: 20,
      metaMargin: 16,
    },

    Descriptions: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      labelColor: '#4A4A4A',
      titleColor: '#2A2A2A',
      padding: 16,
      paddingSM: 12,
      paddingLG: 20,
      borderRadius: 0,
      borderWidth: 2,
    },

    Avatar: {
      colorBgContainer: '#D0C8A8',
      colorText: '#2A2A2A',
      borderRadius: 0,
      borderRadiusLG: 0,
      borderRadiusSM: 0,
      size: 40,
      sizeLG: 56,
      sizeSM: 28,
    },

    Badge: {
      borderRadius: 0,
      colorBgContainer: '#F28B82',
      colorText: '#FFFFFF',
      dotSize: 10,
      shadowSize: 0,
    },

    Tag: {
      colorBgContainer: '#E0F0FF',
      colorBorder: '#3A3A3A',
      colorText: '#2A2A2A',
      borderRadius: 0,
      defaultBg: '#E0F0FF',
      defaultColor: '#2A2A2A',
      borderWidth: 2,
    },

    Popover: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      padding: 12,
      borderWidth: 2,
    },

    Tooltip: {
      colorBgSpotlight: '#3A3A3A',
      colorTextLightSolid: '#FFFFFF',
      borderRadius: 0,
      fontSize: 12,
      padding: 8,
    },

    Popconfirm: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      borderWidth: 2,
    },

    Dropdown: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      padding: 4,
      borderWidth: 2,
    },

    Tree: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      nodeHoverColor: 'rgba(74, 155, 217, 0.04)',
      nodeSelectedColor: 'rgba(74, 155, 217, 0.10)',
      indentSize: 16,
      borderRadius: 0,
    },

    Calendar: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      fullBg: '#F5EDD6',
      fullPanelBg: '#FFFDF5',
      itemActiveBg: 'rgba(74, 155, 217, 0.10)',
    },

    Statistic: {
      colorBgContainer: '#FFFDF5',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      titleFontSize: 14,
      contentFontSize: 26,
    },

    Comment: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      padding: 16,
    },

    Carousel: {
      colorBgContainer: '#D0C8A8',
      colorText: '#2A2A2A',
      dotHeight: 4,
      dotWidth: 24,
    },

    Collapse: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      headerBg: '#F5EDD6',
      borderRadius: 0,
      padding: 12,
      borderWidth: 2,
    },

    Timeline: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      dotBg: '#4A9BD9',
      tailColor: '#3A3A3A',
    },

    // ========== 反馈组件 ==========

    Alert: {
      borderRadius: 0,
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      padding: 12,
      paddingSM: 8,
      borderWidth: 2,
    },

    Notification: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      padding: 16,
      paddingLG: 20,
      borderWidth: 2,
    },

    Message: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      padding: 12,
      borderWidth: 2,
    },

    Modal: {
      borderRadiusLG: 0,
      boxShadow: 'inset -3px -3px 0 #3A3A3A, inset 3px 3px 0 #FFFFFF',
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      headerBg: '#4A9BD9',
      headerColor: '#FFFFFF',
      titleColor: '#FFFFFF',
      titleFontSize: 20,
      padding: 24,
      paddingLG: 28,
      paddingMD: 20,
      paddingXS: 16,
      borderWidth: 2,
    },

    Drawer: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      borderRadiusLG: 0,
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      padding: 24,
      titleColor: '#2A2A2A',
      titleFontSize: 18,
      borderWidth: 2,
    },

    Progress: {
      colorBgContainer: '#D0C8A8',
      colorText: '#4A4A4A',
      colorTextSecondary: '#7A7A7A',
      defaultColor: '#7BC87E',
      remainingColor: '#D0C8A8',
      borderRadius: 0,
      lineWidth: 10,
    },

    Result: {
      colorBgContainer: '#FFFDF5',
      colorText: '#2A2A2A',
      colorTextSecondary: '#4A4A4A',
      titleFontSize: 26,
      subtitleFontSize: 18,
      iconSize: 52,
    },

    Skeleton: {
      colorBgContainer: '#D0C8A8',
      colorText: '#F5EDD6',
      borderRadius: 0,
    },

    Empty: {
      colorBgContainer: 'transparent',
      colorText: '#4A4A4A',
      colorTextSecondary: '#7A7A7A',
    },

    Spin: {
      colorPrimary: '#4A9BD9',
      colorBgContainer: 'rgba(245, 237, 214, 0.8)',
    },

    // ========== 其他组件 ==========

    Anchor: {
      colorBgContainer: 'transparent',
      colorBorder: '#3A3A3A',
      colorText: '#4A4A4A',
      colorTextActive: '#4A9BD9',
      colorTextHover: '#4A9BD9',
    },

    BackTop: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      borderWidth: 2,
    },

    Affix: {},

    Watermark: {},

    ConfigProvider: {},

    App: {
      colorBgContainer: '#F5EDD6',
      colorText: '#2A2A2A',
    },

    QRCode: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      borderWidth: 2,
    },

    Tour: {
      colorBgContainer: '#FFFDF5',
      colorBorder: '#3A3A3A',
      borderRadius: 0,
      boxShadow: 'inset -2px -2px 0 #3A3A3A, inset 2px 2px 0 #FFFFFF',
      borderWidth: 2,
    },
  },
};